import slices from './slices';

export default {
  ...slices.skills.actions,
};
